import { ProductName } from 'engageTools/studio/schema'
import { Language, getLanguagesDict } from 'utils/languages'

export function transformLanguagesIntoOptions(languages: string[]): Language[] {
    return getLanguagesDict().filter((language) => languages.includes(language.value))
}

export function getAvailableLanguages(accountLanguages: string[], product: ProductName): string[] {
    if (product === 'wonderbar') {
        return getLanguagesDict().filter(({ value }) => accountLanguages.includes(value)).map(({ value }) => value)
    }
    return accountLanguages
}
